import DashboardAdmin from "../views/dashboard/dashboardAdmin.vue";
import DashboardUser from "../views/dashboard/dashboardUser.vue";
import Landing from "../views/landing.vue";
import SignIn from "../views/signin.vue";
import SignUp from "../views/signup.vue";
import createProvider from "../views/providers/createProvider.vue";
import myProviders from "../views/providers/myProviders.vue";
import editProvider from "../views/providers/editProvider.vue";
import createProduct from "../views/products/createProduct.vue";
import myProducts from "../views/products/myProducts.vue";
import editProduct from "../views/products/editProduct.vue";
import createGasoilSupply from "../views/supplies/gasoilSupplies/createGasoilSupply.vue";
import editGasoilSupply from "../views/supplies/gasoilSupplies/editGasoilSupply.vue";
import myGasoilSupplies from "../views/supplies/gasoilSupplies/myGasoilSupplies.vue";
import createFertilizerSupply from "../views/supplies/fertilizerSupplies/createFertilizerSupply.vue";
import editFertilizerSupply from "../views/supplies/fertilizerSupplies/editFertilizerSupply.vue";
import myFertilizerSupplies from "../views/supplies/fertilizerSupplies/myFertilizerSupplies.vue";
import createFertilizerAndPhytosanitarySupply from "../views/supplies/fertilizerAndPhytosanitarySupplies/createFertilizerAndPhytosanitarySupply.vue";
import editFertilizerAndPhytosanitarySupply from "../views/supplies/fertilizerAndPhytosanitarySupplies/editFertilizerAndPhytosanitarySupply.vue";
import myFertilizerAndPhytosanitarySupplies from "../views/supplies/fertilizerAndPhytosanitarySupplies/myFertilizerAndPhytosanitarySupplies.vue";
import createPhytosanitarySupply from "../views/supplies/phytosanitarySupplies/createPhytosanitarySupply.vue";
import editPhytosanitarySupply from "../views/supplies/phytosanitarySupplies/editPhytosanitarySupply.vue";
import myPhytosanitarySupplies from "../views/supplies/phytosanitarySupplies/myPhytosanitarySupplies.vue";
import createAdditiveSupply from "../views/supplies/additiveSupplies/createAdditiveSupply.vue";
import editAdditiveSupply from "../views/supplies/additiveSupplies/editAdditiveSupply.vue";
import myAdditiveSupplies from "../views/supplies/additiveSupplies/myAdditiveSupplies.vue";
import createSeed from "../views/seeds/createSeed.vue";
import editSeed from "../views/seeds/editSeed.vue";
import mySeeds from "../views/seeds/mySeeds.vue";
import myPlans from "../views/plans/myPlans.vue";
import createPlan from "../views/plans/createPlan.vue";
import editPlan from "../views/plans/editPlan.vue";

import useAuth from "../store/auth";

const dashboardRoutes = {
  name: "dashboard",
  path: "/app/dashboard",
  component: () => import("../views/dashboard/dashboards.vue"),
  children: [
    {
      path: "admin",
      name: "dashboardAdmin",
      component: DashboardAdmin,
    },
    {
      path: "user",
      name: "dashboardUser",
      component: DashboardUser,
    },
  ],
};

const providerRoutes = {
  path: "/app/providers",
  name: "provider",
  component: () => import("../views/providers/providers.vue"),
  children: [
    {
      path: "list",
      name: "provider-list",
      component: myProviders,
    },
    {
      path: "create",
      name: "create-provider",
      component: createProvider,
    },
    {
      path: ":id/edit",
      name: "edit-provider",
      component: editProvider,
    },
  ],
};

const productRoutes = {
  path: "/app/products",
  name: "product",
  component: () => import("../views/products/products.vue"),
  children: [
    {
      path: "list",
      name: "product-list",
      component: myProducts,
    },
    {
      path: "create",
      name: "create-product",
      component: createProduct,
    },
    {
      path: ":id/edit",
      name: "edit-product",
      component: editProduct,
    },
  ],
};

const plansRoutes = {
  path: "/app/plans",
  name: "plans",
  component: () => import("../views/plans/plans.vue"),
  beforeEnter: (to, from) => {
    const authStore = useAuth();
    if (authStore.isAdmin) {
      return { name: "dashboardAdmin" };
    }
  },
  children: [
    {
      path: "list",
      name: "plan-list",
      component: myPlans,
    },
    // {
    //   path: "create",
    //   name: "create-plan",
    //   component: createPlan,
    // },
    {
      path: ":id/edit",
      name: "edit-plan",
      component: editPlan,
    },
  ],
};

const gasoilSupplyRoutes = {
  path: "/app/supplies/gasoil",
  name: "gasoilSupply",
  component: () => import("../views/supplies/gasoilSupplies/gasoilSupplies.vue"),
  children: [
    {
      path: "list",
      name: "gasoil-supplies-list",
      component: myGasoilSupplies,
    },
    {
      path: "create",
      name: "create-gasoil-supply",
      component: createGasoilSupply,
    },
    {
      path: ":id/edit",
      name: "edit-gasoil-supply",
      component: editGasoilSupply,
    },
  ],
};

const fertilizerSupplyRoutes = {
  path: "/app/supplies/fertilizer",
  name: "fertilizerSupply",
  component: () => import("../views/supplies/fertilizerSupplies/fertilizerSupplies.vue"),
  children: [
    {
      path: "list",
      name: "fertilizer-suppliers-list",
      component: myFertilizerSupplies,
    },
    {
      path: "create",
      name: "create-fertilizer-supply",
      component: createFertilizerSupply,
    },
    {
      path: ":id/edit",
      name: "edit-fertilizer-supply",
      component: editFertilizerSupply,
    },
  ],
};

const fertilizerAndPhytosanitarySupplyRoutes = {
  path: "/app/supplies/fertilizerAndPhytosanitary",
  name: "fertilizerAndPhytosanitarySupply",
  component: () =>
    import(
      "../views/supplies/fertilizerAndPhytosanitarySupplies/fertilizerAndPhytosanitarySupplies.vue"
    ),
  children: [
    {
      path: "list",
      name: "fertilizerAndPhytosanitary-suppliers-list",
      component: myFertilizerAndPhytosanitarySupplies,
    },
    {
      path: "create",
      name: "create-fertilizerAndPhytosanitary-supply",
      component: createFertilizerAndPhytosanitarySupply,
    },
    {
      path: ":id/edit",
      name: "edit-fertilizerAndPhytosanitary-supply",
      component: editFertilizerAndPhytosanitarySupply,
    },
  ],
};

const phytosanitarySupplyRoutes = {
  path: "/app/supplies/phytosanitary",
  name: "phytosanitarySupply",
  component: () => import("../views/supplies/phytosanitarySupplies/phytosanitarySupplies.vue"),
  children: [
    {
      path: "list",
      name: "phytosanitary-suppliers-list",
      component: myPhytosanitarySupplies,
    },
    {
      path: "create",
      name: "create-phytosanitary-supply",
      component: createPhytosanitarySupply,
    },
    {
      path: ":id/edit",
      name: "edit-phytosanitary-supply",
      component: editPhytosanitarySupply,
    },
  ],
};

const seedRoutes = {
  path: "/app/supplies/seed",
  name: "seedSupply",
  component: () => import("../views/seeds/seeds.vue"),
  children: [
    {
      path: "list",
      name: "seed-suppliers-list",
      component: mySeeds,
    },
    {
      path: "create",
      name: "create-seed-supply",
      component: createSeed,
    },
    {
      path: ":id/edit",
      name: "edit-seed-supply",
      component: editSeed,
    },
  ],
};

const additiveSupplyRoutes = {
  path: "/app/supplies/additives",
  name: "additiveSupply",
  component: () => import("../views/supplies/additiveSupplies/additiveSupplies.vue"),
  children: [
    {
      path: "list",
      name: "additive-suppliers-list",
      component: myAdditiveSupplies,
    },
    {
      path: "create",
      name: "create-additive-supply",
      component: createAdditiveSupply,
    },
    {
      path: ":id/edit",
      name: "edit-additive-supply",
      component: editAdditiveSupply,
    },
  ],
};

const createPlanRoutes = {
  path: "/app/create-plan",
  name: "createPlansLogged",
  component: createPlan,
  beforeEnter: (to, from) => {
    const authStore = useAuth();
    if (authStore.isAdmin) {
      return { name: "dashboardAdmin" };
    }
  },
};

const routes = [
  {
    name: "layout",
    path: "/app",
    component: () => import("../layout/index.vue"),
    children: [
      dashboardRoutes,
      providerRoutes,
      productRoutes,
      gasoilSupplyRoutes,
      fertilizerSupplyRoutes,
      fertilizerAndPhytosanitarySupplyRoutes,
      phytosanitarySupplyRoutes,
      additiveSupplyRoutes,
      seedRoutes,
      plansRoutes,
      createPlanRoutes,
    ],
  },
  {
    path: "/",
    name: "create-plan",
    component: createPlan,
    beforeEnter: async (to, from) => {
      const authStore = useAuth();
      if (authStore.isAdmin) {
        return { name: "dashboardAdmin" };
      } else if (await authStore.isLoggedInAndHaveCreatedPlans) {
        return { name: "plan-list" };
      } else {
        return;
      }
    },
  },
];

export default routes;

